module.exports = __webpack_public_path__ + "static/media/background.e9162211.jpg";